<template>
<el-container>
 <el-main> 
    <el-form :inline="true" :model="formRoleList" class="demo-form-inline">
      <!-- 编辑角色 -->
      <el-dialog
      :title="opTitle"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addRoleVisible"
      width="480px"
      >
      <el-form-item :label="$t('role.roleName')" label-width="100px" style="margin-top:-20px">
          <el-input
              type="text"
              v-model="addRoleForm.roleName"
              maxlength="30" 
              show-word-limit
              :placeholder="$t('role.roleName')"
              style="width:200px"
            ></el-input>
      </el-form-item>  
      <el-form-item :label="$t('role.permissions')" label-width="100px" style="margin-top:-10px">
        <div style="width:300px;height:250px">
         <el-scrollbar style="height:100%"> 
          <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('role.checkAll')}}</el-checkbox>
          <el-checkbox-group v-model="checkedAuth" @change="handleCheckedAuthChange">
            <el-checkbox v-for="city in authList" :label="city" :key="city.userPermissionId">{{city.permissionName}}</el-checkbox>
          </el-checkbox-group> -->
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            default-expand-all
            :default-checked-keys="checkedAuth"
            :props="defaultProps">
          </el-tree>
        </el-scrollbar>
        <!-- <el-scrollbar style="height:100%"> 
          <div v-for="item in authList" v-bind:key="item.userPermissionId">
               <el-checkbox :indeterminate="isIndeterminate" v-model="checkedPAuth" @change="handleCheckAllChange">{{item.permissionName}}</el-checkbox>
               <el-checkbox-group  v-model="checkedAuth" @change="handleCheckedCHAuthChange">
                  <el-checkbox v-for="city in item.chAuth" :label="city" :key="city.userPermissionId">{{city.permissionName}}</el-checkbox>
               </el-checkbox-group>
          </div>
         </el-scrollbar> -->
       </div>
      </el-form-item>
      <el-row style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="onSubmit">{{$t('role.confrim')}}</el-button>
          <el-button type="primary" @click="addRoleVisible = false">{{$t('role.cancel')}}</el-button>
      </el-row> 
    </el-dialog>  
    <el-form-item :label="$t('role.roleName')">
          <el-input v-model="formRoleList.roleName" :placeholder="$t('role.roleName-input')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSelect">{{$t('role.qurey')}}</el-button>
        </el-form-item>
         <el-form-item style="float:right">
            <el-button icon="el-icon-plus" style="float:right;" @click="handleAdd">{{$t('role.addRole')}}</el-button>  
         </el-form-item>
    </el-form>
    <template>
  
    <el-table :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#606266'}" empty-text="No Data" border>
        <el-table-column type="index" :label="$t('role.number')" width="100" align="center"></el-table-column>
        <el-table-column prop="roleName" :label="$t('role.roleName')" align="center" width="160"></el-table-column>
        <el-table-column prop="roleRemark" :label="$t('role.remark')" align="center"></el-table-column>
        <el-table-column prop="status" :label="$t('role.status')" align="center">
          <template slot-scope="scope">
             {{scope.row.status==0?$t('role.stop'):scope.row.status==1?$t('role.start'):$t('role.delete')}}
          </template>  
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('role.createTime')" :formatter="this.$util.datetimeFormat" align="center"></el-table-column>
        <el-table-column prop="" :label="$t('role.operate')" align="center" width="160">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" :title="$t('role.edit')" @click="handleEdit(scope.$index, scope.row)">{{$t('role.edit')}}</el-button>
            <el-button type="danger" size="mini" :title="$t('role.delete')" @click="onDelete(scope.$index, scope.row)">{{$t('role.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-main>
  <el-footer>
    <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
    </div>
  </el-footer>    
</el-container>  
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "lockList", //这个LoginName最好和引入的vue的LoginName相同
   data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeData:[],
      checkAll: false,
      checkedAuth: [],
      // checkedPAuth:[],
      authList: [],
      isIndeterminate: true,
      
      addRoleVisible:false,
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      formRoleList: {
        roleName: ""
      },
      addRoleForm:{
         roleId:"",
         roleName:"",
         opType:0
      },
      opTitle:this.$t('role.addRole')
    };
  },
  components: {
    Pagings
  },
  created() {
    this.power();
    this.getPermissionList();
  },
  methods: {
    //新增角色
    handleAdd(){
      this.opTitle=this.$t('role.addRole');
      this.addRoleVisible=true;
       this.addRoleForm.roleId='';
       this.addRoleForm.roleName="";
       this.addRoleForm.opType=0;
       this.getPermissionList();
    },
    
    //编辑角色
    handleEdit(index,row){
       this.opTitle=this.$t('update.editRole');
       this.addRoleVisible=true;
       this.addRoleForm.roleName=row.roleName;
       this.getPermissionList(row.roleId);
       this.addRoleForm.roleId=row.roleId;
       this.addRoleForm.opType=1;
    },
    onSubmit() {
      if(this.addRoleForm.roleName=="" ||this.addRoleForm.roleName==null){
          this.$message({
            message: this.$t("role.roleName-input"),
            type: "warning"
          });
          return false;
      }
      if(this.checkedAuth.length==0 ||this.checkedAuth==null){
          this.$message({
            message:  this.$t("role.rolePermissions-select"),
            type: "warning"
          });
          return false;
      }
      var authList=[];
      this.checkedAuth.filter(function (item) {
        authList.push(item.userPermissionId);
      });
      //opType=0添加权限，否则编辑权限
      if(this.addRoleForm.opType==0){
        var formData = new FormData();
        formData.append("roleName", this.addRoleForm.roleName);
        formData.append("permissionIdList",window.JSON.stringify(authList));
        formData.append("roleRemark",this.addRoleForm.roleName);
        this.$server
        .exam("/customer/userRole/addRole", formData)
        .then(data => {
          this.addRoleVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
             });
             this.power();
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
      }else{
        var formData = new FormData();
        formData.append("roleId", this.addRoleForm.roleId);
        formData.append("roleName", this.addRoleForm.roleName);
        formData.append("permissionIdList",window.JSON.stringify(authList));
        formData.append("roleRemark",this.addRoleForm.roleName);
        this.$server
        .exam("/customer/userRole/editRole", formData)
        .then(data => {
          this.addRoleVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
             });
             this.power();
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
      }
     
    },
    onSelect(){
        this.power();
    },
    onDelete(index,row){
      this.$confirm(this.$t("role.deleteRole-confrim1")+row.roleName+this.$t("role.deleteRole-confrim2"), this.$t("role.hint"), {
          confirmButtonText:this.$t("role.confrim"),
          cancelButtonText: this.$t("role.cancel"),
          type: 'warning'
        }).then(() => {
          var formData = new FormData();
          formData.append("roleId",row.roleId);
          this.$server
          .exam("/customer/userRole/deleteRole", formData)
          .then(data => {
           if (data.code == 200) {
             this.$message({
              message: this.$t("role.deleteSucc"),
              type: "success"
            });
            this.power();
           } else {
             this.$message({
               message: data.message,
               type: "warning"
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message:  this.$t("role.cancelDelete")
          });          
      });
    },
    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      if(this.formRoleList.roleName!="" && this.formRoleList.roleName!=null){
          formData.append("roleName",this.formRoleList.roleName);
      }
      this.$server
        .exam("/customer/userRole/listRole", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    getPermissionList(roleId){
        var formData = new FormData();
        if(roleId!=""&&roleId!=null&&roleId!=undefined){
          formData.append("roleId",roleId);
        }
        this.$server
        .exam("/customer/userRole/listPermission", formData)
        .then(data => {
          if (data.code == 200) {
              this.authList=data.data;
              if(this.addRoleForm.opType==0){//0新增,1编辑
                  this.treeOrder(data.data)
                  // var data=this.orderAuth(data.data);
                  this.checkedAuth=data.data;
              }
              else{
                var data=data.data;
                var list=[];
                data.filter(function (item) {
                     if(item.hadPermission=='1'){
                       list.push(item)
                     }
                 });
                 this.checkedAuth=list
              }
            //  console.log(JSON.stringify(this.checkedAuth));
            //  this.changeAuthList(authList);
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    treeOrder(data){
      console.log(JSON.stringify(data));
      var treeData=[];
      for(var str in data){
          var pId=data[str].partnerPermissionId;
          var treeObj={};
          if(pId==0){
            treeObj.id=data[str].userPermissionId;
            treeObj.label=data[str].permissionName;
            treeObj.children=[];
            treeData.push(treeObj);
          }
          var hadPermission=data[str].hadPermission;
          //获取已经选中的权限
          if(hadPermission==1){
            this.checkedAuth.push(data[str].userPermissionId);
          }
      }
      for(var str in data){
          var pId=data[str].partnerPermissionId;
          var treeObj={};
          if(pId>0){
             for(var obj in treeData){
               if(pId==treeData[obj].id){
                 var chObj={};
                 chObj.id=data[str].userPermissionId;
                 chObj.label=data[str].permissionName;
                 treeData[obj].children.push(chObj)
               }
             } 
          }
      }
      // console.log(JSON.stringify(treeData));
      this.treeData=treeData;
    },
   changeAuthList(authData){
       var pAuthList=[];
       for(var i=0;i<authData.length;i++){
          var pAuthData={};
          if(authData[i].partnerPermissionId==0){
             pAuthData=authData[i];
             pAuthData.chAuth=[];
             pAuthList.push(pAuthData);
             this.checkedPAuth.push(pAuthData);
          }
       }
       this.setChAuthList(pAuthList,authData);
    },
    setChAuthList(pAuthList,authData){
      for(var i=0;i<authData.length;i++){
        if(authData[i].partnerPermissionId!=0){
           for(var j=0;j<pAuthList.length;j++){
               if(pAuthList[j].userPermissionId==authData[i].partnerPermissionId){
                    pAuthList[j].chAuth.push(authData[i]);
                    this.checkedAuth.push(authData[i]);
               }
           }
        }
      }
      this.authList=pAuthList;
    },
    //全选权限
    // handleCheckAllChange(val) {
    //     console.log(JSON.stringify(val));
    //     this.checkedAuth = val ? this.authList : [];
    //     this.isIndeterminate = false;
    // },

    // //单选权限
    // handleCheckedAuthChange(value) {
    //     let checkedCount = value.length;
    //     this.checkAll = checkedCount === this.authList.length;
    //     this.isIndeterminate = checkedCount > 0 && checkedCount < this.authList.length;
    //     if(!this.checkAll){
    //        this.isIndeterminate=false
    //     }
    // },

    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    },
    orderAuth(authData){
      //  var rtnData=[];
      //  var parentList=[];
      //  for(var str in authData){
      //     switch(authData[str].partnerPermissionId){
      //        case 0:
      //          parentList.push(authData[str].userPermissionId);
      //          rtnData.push((authData[str]));
      //          break; 
      //        default:
      //          break;   
      //     }
      //  }
       return authData;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/butler/roleList.vue